<!--Vista para mostrar los eventos de un organizador y posteriormente seleccionar alguno para hacer el check in de los asistentes-->
<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="10" md="8" xl="6" class="elevation-1 mb-5 primary white--text text-center">
            <h1 class="display-2">Eventos disponibles</h1>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12">
            <check-in-list :events="availableEvents" v-on:show-qr="showQr=true"></check-in-list>
            {{selectedEvent}}
            <qr-card :visible="showQr" v-on:hide-qr="showQr=false"></qr-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import qrCard from "@/components/admin/qr-card";
import checkInList from "@/components/admin/checkIn/checkInList";
export default {
  components: {
    qrCard,
    checkInList
  },
  data() {
    return {
      selectedEvent: "",
      showQr: false,
      availableEvents: []
    };
  },
  methods: {
    ...mapMutations("notifications", ["show"]),
    eventStatus(eventDate) {
      let today = new Date();
      let currentDate = new Date(eventDate);
      if (today > currentDate) {
        return false;
      } else {
        return true;
      }
    },
  },
  computed: {
    ...mapState("event", ["events"])
  },
  mounted() {
    this.availableEvents = this.events.map(event => {
      return {
        eventImage: event.eventImage,
        name: event.name,
        estatus: this.eventStatus(event.endDate),
        startDate: new Date(event.startDate).toLocaleDateString("es-MX")
      };
    });
  }
};
</script>